<template>
  <div class="tpehealth-appendix-page col-block" :style="{ height: windowHeight + 'px' }">
    <div class="tpehealth-appendix-container col-block width-full" :style="{ flex: 1, height: 0 }">
      <div ref="chapter-container" class="tpehealth-appendix-block col-block width-full" :style="{ flex: 1 }">
        <div class="tpehealth-appendix-main-container col-block width-full">
          <!-- <div v-if="!$route.params.chapter || ($route.params.chapter === 'testingMethod')" ref="chapter-testingMethod" class="tpehealth-appendix-main-block">
            <div class="tpehealth-appendix-icon-container center-block">
              <img :src="require('@/assets/tpehealth/附錄檢測方法-head.png')" alt="" :style="{ width: '90px' }">
            </div>
            <div class="tpehealth-appendix-title-container col-block width-full">
              <div :style="{ flex: 1 }"></div>
              <div class="tpehealth-appendix-title-block row-block">
                <div class="tpehealth-appendix-title">{{ '附錄：檢測方法'/* ___ */ }}</div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div :style="{ flex: 1 }"></div>
            </div>
            <div class="tpehealth-appendix-sub-container"></div>
            <div class="tpehealth-appendix-content-container col-block width-full">
              <testingMethod
              ></testingMethod>
            </div>
          </div> -->
          <div v-if="!$route.params.chapter || ($route.params.chapter === 'carrierScreening')" ref="chapter-carrierScreening" class="tpehealth-appendix-main-block">
            <div class="tpehealth-appendix-icon-container center-block">
              <img :src="require('@/assets/tpehealth/附錄帶因篩查參考清單-head.png')" alt="" :style="{ width: '90px' }">
            </div>
            <div class="tpehealth-appendix-title-container col-block width-full">
              <div :style="{ flex: 1 }"></div>
              <div class="tpehealth-appendix-title-block row-block">
                <div class="tpehealth-appendix-title">{{ '附錄：帶因篩查參考清單'/* ___ */ }}</div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div :style="{ flex: 1 }"></div>
            </div>
            <div class="tpehealth-appendix-sub-container"></div>
            <div class="tpehealth-appendix-content-container col-block width-full">
              <carrierScreening
              ></carrierScreening>
            </div>
          </div>
          <div v-if="!$route.params.chapter || ($route.params.chapter === 'infertilityGenes')" ref="chapter-infertilityGenes" class="tpehealth-appendix-main-block">
            <div class="tpehealth-appendix-icon-container center-block">
              <img :src="require('@/assets/tpehealth/附錄生殖與生孕基因參考清單-head.png')" alt="" :style="{ width: '80px' }">
            </div>
            <div class="tpehealth-appendix-title-container col-block width-full">
              <div :style="{ flex: 1 }"></div>
              <div class="tpehealth-appendix-title-block row-block">
                <div class="tpehealth-appendix-title">{{ '附錄：生殖與生孕基因參考清單'/* ___ */ }}</div>
                <div :style="{ flex: 1 }"></div>
              </div>
              <div :style="{ flex: 1 }"></div>
            </div>
            <div class="tpehealth-appendix-sub-container"></div>
            <div class="tpehealth-appendix-content-container col-block width-full">
              <pregnancyGene
              ></pregnancyGene>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import testingMethod from '@/components/tpehealth/template/testingMethod.vue'
import carrierScreening from '@/components/tpehealth/template/carrierScreening.vue'
import pregnancyGene from '@/components/tpehealth/template/pregnancyGene.vue'
import responsitiveData from '@/mixins/responsitiveData.vue'

export default {
  components: {
    testingMethod,
    carrierScreening,
    pregnancyGene
  },
  mixins: [
    responsitiveData
  ],
  metaInfo () {
    return {
      title: '全基因體檢測報告'
    }
  },
  mounted () {
    // let target = this.$refs['chapter-' + this.$route.params.chapter]
    // this.$refs['chapter-container'].scrollTo({ top: target.offsetTop - 30 })
  }
}
</script>
